import React from 'react'
import { Modal, ModalProps } from 'antd'
// import './animation.css'

const PrimeModal = (props: ModalProps) => {
  return (
    <Modal
      forceRender
      centered
      transitionName="custom-slide-up"
      {...props}
    ></Modal>
  )
}

export default PrimeModal
